import { render, staticRenderFns } from "./LeaveNoteModal.vue?vue&type=template&id=4a5709f9&"
import script from "./LeaveNoteModal.vue?vue&type=script&lang=js&"
export * from "./LeaveNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports